import React__default from 'react';
import classnames from 'classnames';

const ProductDetailStack = ({ children , className , spacing ='full' ,  })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classnames(className, 'product-detail-stack', {
            'product-detail-stack--full-spacing': spacing === 'full',
            'product-detail-stack--half-spacing': spacing === 'half'
        })
    }, children)
;

export { ProductDetailStack };
//# sourceMappingURL=ProductDetailStack.js.map
